'use strict';

var page = require('./page'),
	googletaglinchpin = require('int_googletagmanager/googletaglinchpin'),
	global = require('./global');

	var pages = {
		checkout: require('./pages/checkout/index'),
		orderconfirmation: require('./pages/orderconfirmation')
	};

var checkoutInitializer = {
	init: function () {
		global.init();

		$.extend(page, window.pageContext);
		var ns = page.ns;
		if (ns && pages[ns] && pages[ns].init) {
			pages[ns].init();
		}

		if (SitePreferences.GTM_ENABLED && window.pageContext.ns) {
			googletaglinchpin.init(window.pageContext.ns);
		}
	}
};

$(document).ready(function () {
	checkoutInitializer.init();
});
